import React, { VoidFunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SingleTabEditDialog,
  SingleTabEditDialogProps
} from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditConstructionSiteForm } from '../EditConstructionSiteForm/EditConstructionSiteForm';

export type EditConstructionSiteDialogProps = PropsWithoutChildren<
  Omit<SingleTabEditDialogProps, 'tabTitle'>
> & {
  constructionSite: ConstructionSite;
};

export const EditConstructionSiteDialog: VoidFunctionComponent<EditConstructionSiteDialogProps> =
  React.memo((props) => {
    const { constructionSite, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const { t } = useTranslation();

    const handlePropertyChanged = useModifyEntityCallback(
      EntityName.ConstructionSite
    );

    return (
      <SingleTabEditDialog
        {...remainingProps}
        tabTitle={t(
          'components.constructionSite.EditConstructionSiteDialog.title'
        )}
      >
        <EditConstructionSiteForm
          constructionSite={constructionSite}
          onPropertyChanged={handlePropertyChanged}
          data-testid="EditConstructionSiteDialog.EditConstructionSiteForm"
        ></EditConstructionSiteForm>
      </SingleTabEditDialog>
    );
  });
